//
// RoutingMode.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var RoutingMode = {
    DIRECT:0,
    DRIVING_TIME:1,
    DRIVING_DISTANCE:2,
    WALKING_TIME:3,
    WALKING_DISTANCE:4,
    TRUCKING_TIME:5,
    TRUCKING_DISTANCE:6
};
export default RoutingMode;
